import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/preact';
import { actions } from 'actions';
import SpectrumQuestionRow from 'components/questions/SpectrumQuestionRow';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/SpectrumQuestion.scss';

const SpectrumQuestion = ({ question, onOptionChanged, isDisabled }) => {
  const { rows, columns, text, id } = question;

  return (
    <fieldset className="csw-fieldset csw-q-spect">
      <legend className="sr-only" aria-hidden={true}>{text}</legend>
      {rows && rows.map((row, index) => {

        const rowId = `csw-q-spect-${id}-${index}`;
        const rowKey = `csw-q-spect-key-${id}-${index}`;

        return (
          <SpectrumQuestionRow
            key={rowKey}
            rowId={rowId}
            row={row}
            columns={columns}
            isDisabled={isDisabled}
            onOptionSelected={(option, row) => onOptionChanged({ option, row })}/>
        );
      })}
    </fieldset>
  );
};

SpectrumQuestion.propTypes /* remove-proptypes */ = {
  question: PropTypes.object,
  onOptionChanged: PropTypes.func,
  isDisabled: PropTypes.bool
};

export default connect(
  '',
  actions
)(SpectrumQuestion);
